import apiSlice from "./apiSlice";

const milestoneDashboardSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        // Get Milestone Data
        getAllMilestone: builder.query({
            query: (id) => ({
                url: `milestone/grouped-dashboard?projectId=${id}`,
                method: 'GET',
            }),
            //keepUnusedDataFor: 5 * 60,
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["Get-Milestone-Data"],
        }),

    }),
});

export default milestoneDashboardSlice;

export const {
    useGetAllMilestoneQuery,
} = milestoneDashboardSlice;